import { render, staticRenderFns } from "./piechart.vue?vue&type=template&id=b5746e4e&scoped=true&"
import script from "./piechart.vue?vue&type=script&lang=js&"
export * from "./piechart.vue?vue&type=script&lang=js&"
import style0 from "./piechart.vue?vue&type=style&index=0&id=b5746e4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5746e4e",
  null
  
)

export default component.exports